<template>
  <div class="section">
    <div class="section-title">{{ lang.sectionTitle }}</div>
    <div class="section-text">{{ lang.sectionText }}</div>
    <form class="input-fields">
      <LabelInput
        :disabled="readOnly"
        @input="
          (value) =>
            (data.firstName = state.lang === 'fa' ? $S2Fa(value) : S2Fa(value))
        "
        :value="data.firstName"
        :label="lang.firstName"
      />
      <LabelInput
        :disabled="readOnly"
        @input="
          (value) =>
            (data.lastName = state.lang === 'fa' ? $S2Fa(value) : S2Fa(value))
        "
        :value="data.lastName"
        :label="lang.lastName"
      />
      <LabelInput
        type="nochar"
        :maxLength="countryName == 'Iran' ? 10 : 50"
        @input="(value) => (data.nationalCode = value)"
        :value="data.nationalCode"
        :disabled="readOnly"
        :label="countryName == 'Iran' ? lang.idCardNumbar : idType"
        dir="ltr"
      >
        <template #append>
          <div
            v-if="countryName != 'Iran'"
            class="id-type"
            v-click-outside="() => (idTypeDrop = false)"
          >
            <button
              type="button"
              class="id-type-btn"
              @click="idTypeDrop = !idTypeDrop"
            >
              {{ idType }}
              <inline-svg
                :src="require('@/assets/icons/arrowdown.svg')"
                class="arrow-icon"
                style="fill: #fff; width: 16px"
              />
            </button>
            <div
              class="id-type-list"
              :style="{
                width: (idTypeDrop ? 150 : 100) + 'px',
                height: (idTypeDrop ? 90 : 0) + 'px',
              }"
            >
              <div>
                <div
                  v-for="(idFormat, index) in idTypes"
                  :key="index"
                  @click="$emit('changeId', idFormat), (idTypeDrop = false)"
                >
                  {{ idFormat }}
                  <!-- lang[idFormat] -->
                </div>
              </div>
            </div>
          </div>
        </template>
      </LabelInput>
      <Calendar
        :disabled="readOnly"
        :isBirth="true"
        @input="(value) => (data.birthDay = value)"
        :value="data.birthDay"
        :label="lang.birthDate"
      />
      <LabelInput
        type="nochar"
        @input="(value) => (data.email = value)"
        :value="data.email"
        :label="lang.email"
        dir="ltr"
        :disabled="true"
      >
        <template #prepend>
          <div class="prepend" dir="ltr">
            <template v-if="state.lang == 'fa'">
              <button
                class="edit-btn"
                type="button"
                @click="(showModal = true), (isMobile = false)"
              >
                <inline-svg
                  fill="#fff"
                  width="20px"
                  :src="require('@/assets/icons/pen-alt-solid.svg')"
                />
              </button>
            </template>
          </div>
        </template>
        <template #append>
          <div class="prepend" dir="ltr">
            <template v-if="state.lang != 'fa'">
              <button
                class="edit-btn"
                type="button"
                @click="(showModal = true), (isMobile = false)"
              >
                <inline-svg
                  fill="#fff"
                  width="20px"
                  :src="require('@/assets/icons/pen-alt-solid.svg')"
                />
              </button>
            </template>
          </div>
        </template>
      </LabelInput>
      <LabelInput
        type="nochar"
        :maxLength="countryName == 'Iran' ? 10 : 15"
        @input="(value) => (data.mobileNumber = value)"
        :value="data.mobileNumber"
        :label="lang.cellPhone"
        dir="ltr"
        :disabled="
          countryName != 'Iran' ||
          !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
            data.authenticationType
          )
        "
      >
        <template #prepend>
          <div class="prepend" dir="ltr">
            <p dir="ltr">{{ countryPhoneCode }}</p>

            <template v-if="state.lang == 'fa'">
              <button
                v-if="
                  countryName != 'Iran' ||
                  !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
                    data.authenticationType
                  )
                "
                class="edit-btn"
                type="button"
                @click="(showModal = true), (isMobile = true)"
              >
                <inline-svg
                  fill="#fff"
                  width="20px"
                  :src="require('@/assets/icons/pen-alt-solid.svg')"
                />
              </button>
            </template>
          </div>
        </template>
        <template #append>
          <div class="prepend" dir="ltr">
            <!-- v-if=" countryName != 'Iran' || !['UNAUTHORIZED', 'UNIDENTIFIED',
            'NOT_COMPLETE'].includes( data.authenticationType ) " -->
            <template v-if="state.lang != 'fa'">
              <button
                v-if="
                  countryName != 'Iran' ||
                  !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
                    data.authenticationType
                  )
                "
                class="edit-btn"
                type="button"
                @click="(showModal = true), (isMobile = true)"
              >
                <inline-svg
                  fill="#fff"
                  width="20px"
                  :src="require('@/assets/icons/pen-alt-solid.svg')"
                />
              </button>
            </template>
          </div>
        </template>
      </LabelInput>
      <LabelInput
        v-if="countryName == 'Iran'"
        type="nochar"
        :maxLength="11"
        @input="(value) => (data.telephone = value)"
        :value="data.telephone"
        :label="lang.wirePhone"
        dir="ltr"
      />
      <LabelInput
        :label="lang.state"
        :value="data.state"
        @input="(value) => (data.state = value)"
      />
      <LabelInput
        :label="lang.city"
        :value="data.city"
        @input="(value) => (data.city = value)"
      />
      <LabelInput
        :label="lang.postalCode"
        type="nochar"
        :maxLength="countryName == 'Iran' ? 10 : 20"
        :value="data.postalCode"
        dir="ltr"
        @input="(value) => (data.postalCode = value)"
      />
      <LabelInput
        @input="(value) => (data.address = value)"
        :value="data.address"
        :label="lang.address"
      />
    </form>
    <edit-modal
      v-if="showModal"
      :data="data"
      :isMobile="isMobile"
      :countryPhoneCode="countryPhoneCode"
      :isIran="countryName == 'Iran'"
      @close="showModal = false"
      @changedMobile="data.mobileNumber = $event.replace(countryPhoneCode, '')"
      @changedEmail="data.email = $event"
    />
  </div>
</template>

<script>
import Calendar from "../../Tools/Calendar";
import ClickOutside from "vue-click-outside";
import EditModal from "@/components/Panel/Profile/EditModal";

export default {
  name: "PersonalFields",
  props: {
    data: Object,
    readOnly: Boolean,
    idTypes: Array,
    idType: String,
    countryName: String,
    countryPhoneCode: String,
  },
  components: {
    Calendar,
    EditModal,
  },
  data() {
    return {
      lang: this.$languageDict().profile.personalFields,
      idTypeDrop: false,
      showModal: false,
      isMobile: false,
    };
  },
  methods: {
    S2Fa(e) {
      return e;
    },
  },
  watch: {
    countryPhoneCode(val) {
      if (this.data.mobileNumber && this.data.mobileNumber.includes(val)) {
        this.data.mobileNumber = this.data.mobileNumber.replace(val, "");
      } else {
        this.data.mobileNumber = "";
      }
    },
    countryName(val) {
      if (val == "Iran") {
        this.$emit("changeId", "ID_CARD");
      }
    },
  },
  directives: { ClickOutside },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.input-fields > div {
  flex-basis: 368px !important;
}

.input-fields {
  margin-top: clamp(16px, 2vw, 24px);
  display: flex;
  column-gap: 16px;
  row-gap: 16px;
  flex-wrap: wrap;
}

textarea:focus {
  outline: none !important;
}

textarea {
  width: 100%;
  background: var(--label-input-bg);
  color: var(--label-input-text);
  border: 0.3px solid var(--label-input-border);
  border-radius: 20px;
}

.id-type {
  position: relative;
  height: 100%;
  color: #fff;
}
.id-type-btn {
  display: flex;
  gap: 6px;
  color: #fff;
  height: calc(100% + 3px);
  background-color: #464956;
  border-radius: 4px 0px 0px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.id-type-list {
  transition: all ease-out 0.3s;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  background-color: #464956;
  border-radius: 0 4px 4px 4px;
  overflow: hidden;
  z-index: 1;
  > div {
    padding: 8px;
    cursor: pointer;
  }
}
.prepend {
  color: #fff;
  display: flex;
  align-items: center;
  p {
    direction: ltr;
  }
}
[dir="rtl"] .prepend {
  p {
    margin-left: 10px;
  }
  .edit-btn {
    margin-right: 0;
    margin-left: 10px;
  }
}

.edit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  cursor: pointer;
  background: linear-gradient(
    90deg,
    #1a97bf 2.72%,
    #721ac9 28.48%,
    #ab0ae3 62.88%,
    #c102c5 78.84%,
    #bb1396 100%
  );
  margin-right: 10px;
}
</style>
